import { Component, Input, OnInit } from '@angular/core';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActivityService } from '../activity.service';

@Component({
  selector: 'app-all-workshop',
  templateUrl: './all-workshop.component.html',
  styleUrls: ['./all-workshop.component.scss'],
})
export class AllWorkshopComponent implements OnInit {
  clearContent: string;
  collectionSize: number;
  rows: any[];
  page: number = 1;
  pageSize: number = 8;

  allWorkshops = [];

  constructor(
    private activityService: ActivityService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.activityService.getAllWorkshops().pipe(
      map((res) => {
        // // console.log(res.result);
        this.allWorkshops = res.result;
        this.refresh();
        this.gobalFunctionService.setSEO('ตารางกิจกรรม (Workshop)', 'website', '');
        // // console.log(this.rows);
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false)
      })
    ).subscribe();

  }
  refresh() {
    this.collectionSize = this.allWorkshops.length;
    this.rows = this.allWorkshops
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
